/**
 * Synchronous bridge from Sidebar submenu clicks → mounted LiveManeuvers instance.
 * Pause/abort must run before host props update so in-flight merge/full fetches do not block the next view.
 */

export type LiveManeuverUpdateGateHandlers = {
  onSubmenuClick: () => void;
};

let activeGate: LiveManeuverUpdateGateHandlers | null = null;

export function registerLiveManeuverUpdateGate(handlers: LiveManeuverUpdateGateHandlers): void {
  activeGate = handlers;
}

export function unregisterLiveManeuverUpdateGate(): void {
  activeGate = null;
}

/** Call synchronously at the start of a live MANEUVERS submenu click (host already active). */
export function notifyLiveManeuverSubmenuClick(): void {
  activeGate?.onSubmenuClick();
}
